"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IIplistFrozen = exports.IIplistInactive = exports.IIplistType = exports.IIplistVersion = void 0;
var IIplistVersion;
(function (IIplistVersion) {
    IIplistVersion[IIplistVersion["IPV_ADDRESSES_FOR_EXAMPLE__4"] = 4] = "IPV_ADDRESSES_FOR_EXAMPLE__4";
    IIplistVersion[IIplistVersion["IPV_ADDRESSES_FOR_EXAMPLE_DBAAE_6"] = 6] = "IPV_ADDRESSES_FOR_EXAMPLE_DBAAE_6";
})(IIplistVersion = exports.IIplistVersion || (exports.IIplistVersion = {}));
var IIplistType;
(function (IIplistType) {
    IIplistType[IIplistType["BLACKLISTED_IP_ADDRESS_RANGE_0"] = 0] = "BLACKLISTED_IP_ADDRESS_RANGE_0";
    IIplistType[IIplistType["WHITELISTED_IP_ADDRESS_RANGE_1"] = 1] = "WHITELISTED_IP_ADDRESS_RANGE_1";
})(IIplistType = exports.IIplistType || (exports.IIplistType = {}));
var IIplistInactive;
(function (IIplistInactive) {
    IIplistInactive[IIplistInactive["ACTIVE_0"] = 0] = "ACTIVE_0";
    IIplistInactive[IIplistInactive["INACTIVE_1"] = 1] = "INACTIVE_1";
})(IIplistInactive = exports.IIplistInactive || (exports.IIplistInactive = {}));
var IIplistFrozen;
(function (IIplistFrozen) {
    IIplistFrozen[IIplistFrozen["NOT_FROZEN_0"] = 0] = "NOT_FROZEN_0";
    IIplistFrozen[IIplistFrozen["FROZEN_1"] = 1] = "FROZEN_1";
})(IIplistFrozen = exports.IIplistFrozen || (exports.IIplistFrozen = {}));
